// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__17JSs","header":"PatientQuestionnaire_header__1c1Ro","info":"PatientQuestionnaire_info__1qt0c"};